import Vue from 'vue'
import Router from 'vue-router'

import Franquia from '@/pages/Franquia'
import HomeApp from '@/pages/HomeApp'
import Login from '@/pages/Login'
import NotFound from '@/pages/NotFound'

import Categorias from '../../../pages/Categorias'
import InfoRestaurante from '../../../pages/InfoRestaurante'
import Pedidos from '../../../pages/Pedidos'
import Perfil from '../../../pages/Perfil'
import Ajuda from '../../../pages/Ajuda'
import ExcluirConta from '../../../pages/ExcluirConta'
import Notificacao from '../../../pages/Notificacao'
import PerfilDados from '../../../pages/PerfilDados'
import PerfilEndereco from '../../../pages/PerfilEndereco'
import PerfilEsqueceuSenha from '../../../pages/PerfilEsqueceuSenha'
import PerfilWhatsapp from '../../../pages/PerfilWhatsapp'
import MeusCartoes from '../../../pages/MeusCartoes'
import NoLocal from '../../../pages/NoLocal'
import LeCard from '../../../pages/LeCard'
import Finalizar from "../../../pages/Finalizar";
import Sacola from "../../../pages/Sacola";
import Promocoes from "../../../pages/Promocoes";
import Links from '../../../pages/Links'
import MeusPontos from '../../../pages/MeusPontos'
import MeusVouchers from '../../../pages/MeusVouchers'

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Franquia',
      component: Franquia
    },
    {
      path: '/home',
      name: 'Home',
      component: HomeApp
    },
    {
      path: '/unidade/:token',
      name: 'Unidade',
      component: HomeApp
    },
    {
      path: '/categorias',
      name: 'Categorias',
      component: Categorias
    },
    {
      path: '/info',
      name: 'InfoRestaurante',
      component: InfoRestaurante
    },
    {
      path: '/sacola',
      name: 'Sacola',
      component: Sacola
    },
    {
      path: '/promocoes',
      name: 'Promocoes',
      component: Promocoes
    },
    {
      path: '/finalizar',
      name: 'Finalizar',
      component: Finalizar
    },
    {
      path: '/pedidos',
      name: 'Pedidos',
      component: Pedidos
    },
    {
      path: '/perfil',
      name: 'Perfil',
      component: Perfil
    },
    {
      path: '/ajuda',
      name: 'Ajuda',
      component: Ajuda
    },
    {
      path: '/excluir-conta',
      name: 'ExcluirConta',
      component: ExcluirConta
    },
    {
      path: '/notificacao',
      name: 'Notificacao',
      component: Notificacao
    },
    {
      path: '/perfil/whatsapp',
      name: 'PerfilWhatsapp',
      component: PerfilWhatsapp
    },
    {
      path: '/perfil/login',
      name: 'Login',
      component: PerfilDados
    },
    {
      path: '/perfil/login/whatsapp',
      name: 'LoginWhatsapp',
      component: PerfilWhatsapp
    },
    {
      path: '/perfil/cadastro',
      name: 'Cadastro',
      component: PerfilDados
    },
    {
      path: '/perfil/esqueci-senha',
      name: 'EsqueceuSenha',
      component: PerfilEsqueceuSenha
    },
    {
      path: '/perfil/esqueci-senha-whatsapp',
      name: 'EsqueceuSenhaWhatsapp',
      component: PerfilWhatsapp
    },
    {
      path: '/perfil/enderecos',
      name: 'PerfilEndereco',
      component: PerfilEndereco
    },
    {
      path: '/perfil/meus-dados',
      name: 'MeusDados',
      component: PerfilDados
    },
    {
      path: '/perfil/telefone',
      name: 'Telefone',
      component: PerfilDados
    },
    {
      path: '/perfil/meus-pontos',
      name: 'MeusPontos',
      component: MeusPontos
    },
    {
      path: '/perfil/meus-vouchers',
      name: 'MeusVouchers',
      component: MeusVouchers
    },
    {
      path: '/perfil/meus-cartoes',
      name: 'MeusCartoes',
      component: MeusCartoes
    },
    {
      path: '/lecard-delivery',
      name: 'LeCard',
      component: LeCard
    },
    {
      path: '/home/nolocal',
      redirect: '/nolocal'
    },
    {
      path: '/nolocal',
      name: 'NoLocal',
      component: NoLocal
    },
    {
      path: '/fidelidade',
      name: 'Fidelidade',
      component: Promocoes
    },
    {
      path: '/unidade/:token/nolocal',
      name: 'NaMesaFranquia',
      component: NoLocal
    },
    {
      path: '/links',
      name: 'Links',
      component: Links
    },
    {
      path: '/*',
      name: 'NotFound',
      component: NotFound
    }
  ]
})
